/* eslint-disable */
import React, { useEffect } from "react";
import { getWallets } from "../../../actions/appExpandedActions/finances";
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";

const Wallets = ({ getWallets, wallets, period }) => {
  // Initial load
  useEffect(() => {
    getWallets({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support both new PeriodSelector and legacy formats
  useEffect(() => {
    // For "All time" (both null), send empty strings
    if (!period?.startDate && !period?.endDate) {
      getWallets({
        page: 1,
        limit: 20,
        startDate: "",
        endDate: ""
      });
    } else if (period?.startDate) {
      // For specific periods, send the actual dates
      getWallets({
        page: 1,
        limit: 20,
        startDate: period?.startDate || "",
        endDate: period?.endDate || "",
      });
    }
  }, [period]);

  const handleLoadMore = (page) => {
    // Use the same logic for load more
    const payload = {
      page,
      limit: 20
    };
    
    if (!period?.startDate && !period?.endDate) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate) {
      payload.startDate = period?.startDate || "";
      payload.endDate = period?.endDate || "";
    }
    
    getWallets(payload);
  };

  return (
    <DataTable
      {...tablePresets.wallets}
      data={wallets}
      fetchData={getWallets}
      period={period}
      onLoadMore={handleLoadMore}
    />
  );
};

const mapStateToProps = (state) => ({
  wallets: state.appFinances.wallets
});

const mapDispatchToProps = (dispatch) => ({
  getWallets: (payload) => dispatch(getWallets(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Wallets);
